<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="1200"
      persistent
      scrollable
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="blue"
          dark
          v-on="on"
          @click="dialog = true"
        >
          <v-icon small left>mdi-send</v-icon> Tramitar
        </v-btn>
      </template>

      <v-card v-if="dialog">
        <v-toolbar flat>
          <v-toolbar-title>
            <v-icon>mdi-send</v-icon>
            <span>Tramitar Processo</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid>
                <div class="d-flex">
                  <div :cols="4">
                    <v-autocomplete
                      class="text-truncate"
                      v-model="administrativeUnitId"
                      label="Setor"
                      :items="administrativeUnits"
                      item-text="name"
                      item-value="id"
                      flat
                      solo
                      :rules="[validationRules.required]"
                      @input="changeAdministrativeUnit()"
                      no-data-text="Setor não encontrado"
                    />
                  </div>
                  <div style="max-width: 400px" :cols="4" class="d-flex align-flex-start" >
                    <v-autocomplete
                      class="text-truncate"
                      v-model="employeeId"
                      label="Colaborador (Opcional)"
                      :items="employees"
                      item-text="name"
                      item-value="id"
                      flat
                      solo
                      clearable
                      :loading="loadingAutocomplete"
                      no-data-text="Colaborador não encontrado!"
                      :disabled="administrativeUnitId === null"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, selected }"
                      >
                        <v-list-tile-avatar
                          class="mr-1"
                          slot="activator"
                          v-if="item.avatar !== null"
                        >
                          <img :src="item.avatar" />
                        </v-list-tile-avatar>
                        <v-list-tile-avatar
                          class="mr-1"
                          color="grey lighten-2"
                          v-else
                        >
                          <span>{{ acronym(item.name) }}</span>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="shortName(item.name)"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.role.name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>

                      <template
                        slot="item"
                        slot-scope="{ item }"
                      >
                        <v-list-tile-avatar
                          class="mr-1"
                          slot="activator"
                          v-if="item.avatar !== null"
                        >
                          <img :src="item.avatar" />
                        </v-list-tile-avatar>
                        <v-list-tile-avatar
                          class="mr-1"
                          color="grey lighten-2"
                          v-else
                        >
                          <span>{{ acronym(item.name) }}</span>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="shortName(item.name)"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.role.name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                    <v-tooltip top
                               max-width="300"
                               :z-index="300">
                      <v-icon size="16" small slot="activator">mdi-information</v-icon>
                      <span>Caso não seja informado um funcionário específico para receber o processo,
                        todos os funcionários que estão alocados no setor irão receber a notificação
                        de que um novo processo foi enviado para o seu setor.
                      </span>
                    </v-tooltip>
                  </div>
                  <div :cols="4">
                    <v-autocomplete
                      class="text-truncate"
                      v-model="dispatchId"
                      label="Despacho padrão (Opcional)"
                      :items="dispatches"
                      item-text="title"
                      item-value="id"
                      flat
                      solo
                      :loading="loadingAutocomplete"
                      @input="selectDispatch()"
                      :disabled="administrativeUnitId === null"
                      no-data-text="Nenhum despacho cadastrado com o termo informado"
                    />
                  </div>
                </div>
            </v-container>
            <v-container fluid v-if="attachedFolders.length">
              <v-layout row>
                <v-flex xs4>
                  <v-checkbox
                    v-model="transactAll"
                    @click="toggle"
                    label="Tramitar os processos apensados"
                  />
                </v-flex>
                <v-flex xs4>
                  <v-select
                    v-model="selectedFolders"
                    :items="attachedFolders"
                    item-text="process_number"
                    placeholder="Tramitar processos apensados"
                    multiple
                    return-object
                    color="docgo"
                  >
                    <template v-slot:selection="{ index }">
                      <span v-if="index === 0" class="grey--text">
                        <span v-if="allFolder">Todos os processos selecionados</span>
                        <span v-else-if="someFolder">{{ selectedFolders.length }} processos selecionados</span>
                      </span>
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-tile
                        ripple
                        @click="toggle"
                      >
                        <v-list-tile-action>
                          <v-icon :color="selectedFolders.length > 0 ? 'docgo' : ''">{{ selectionIcon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>Selecionar todos</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container fluid>
              <span class="subheading grey--text text--darken-1">
                Conteúdo do despacho
              </span>
              <editor :init="editorOptions" id="1" v-model="content" :value="content" @input="html = $event"></editor>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>

            <v-btn
              flat
              @click="cancelTransaction"
              :disabled="loadingTransaction">
              Fechar
            </v-btn>

            <request-password-dialog
              confirmation-button="Tramitar"
              :loading="loadingTransaction"
              :disabled="!transactionValidator()"
              @onSuccess="requestPasswordOnSuccessCallback($event)"
              @onCancel="requestPasswordOnCancelCallback"
            />

          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSuccessTransaction"
      persistent max-width="450">
      <v-card>
        <v-card-title class="headline blue darken-2 white--text" primary-title>Tramitação realizada com Sucesso</v-card-title>
        <v-card-text>Processo foi tramitado com sucesso para o setor informado. Ao confirmar, essa janela será encerrada.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close()">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import RequestPasswordDialog from '@/components/shared/dialogs/RequestPasswordDialog';
import TransactionsService from '@/services/TransactionsService';
import AdministrativeUnitService from '@/services/system/AdministrativeUnitService';

import Editor from '@tinymce/tinymce-vue';
import FolderService from '@/services/FoldersService';

import validationRules from '@/mixins/validation-rules';
import acronym from '@/utils/acronym';
import shortName from '@/utils/short-name';
import TINYMCE_OPTIONS from '@/constants/TINYMCE_OPTIONS';
import { find, remove } from 'lodash';

export default {
  name: 'TransactFolder',
  components: { Editor, RequestPasswordDialog },
  data() {
    return {
      valid: false,
      dialog: false,
      dialogSuccessTransaction: false,
      editorOptions: TINYMCE_OPTIONS(),
      content: '',
      password: '',

      transactAll: true,
      selectedFolders: [],

      administrativeUnits: [],
      administrativeUnitId: null,

      dispatchId: null,
      dispatches: [],

      employeeId: null,
      employees: [],

      loadingAutocomplete: false,
      loadingTransaction: false,
      sendingTransaction: false,

      acronym,
      shortName,

      validationRules,
    };
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    },
  },
  async mounted() {
    this.administrativeUnits = (await TransactionsService.nextAdministrativeUnits());
    this.selectedFolders = this.attachedFolders;
  },
  methods: {
    async changeAdministrativeUnit(){
      if (this.administrativeUnitId == null)
        return;

      const vm = this;
      this.loadingAutocomplete = true;
      this.employees = remove(await AdministrativeUnitService
        .employees(this.administrativeUnitId), (emp) => {
          return emp.id !== vm.user.id
      });
      this.dispatches = await AdministrativeUnitService.dispatches(this.administrativeUnitId);
      this.loadingAutocomplete = false;
    },
    async requestPasswordOnSuccessCallback(event) {
      this.loadingTransaction = true;
      const attached = this.selectedFolders.map(folder => folder.id);
      const detached = [];

      this.attachedFolders.forEach(folder => {
        if(!this.selectedFolders.some(e => e.id == folder.id)) {
          detached.push(folder.id)
        }
      });

      try {
        const coordinates = await this.$getLocation();
        this.sendTransaction({ password: event.password, coordinates, attached, detached})
      } catch (e) {
        this.onRequestError('Você deve autorizar a obtenção da sua localização para prosseguir com essa ação.');
          this.loadingTransaction = false;
      }
    },
    sendTransaction({password, coordinates, attached, detached}) {
      if(this.sendingTransaction) return;
      this.sendingTransaction = true;

      const body = {
        sign_go_password: password,
        geolocation: `${coordinates.lat}, ${coordinates.lng}`,
        attached_folder_ids: attached,
        detached_folder_ids: detached,
        filled_fields: {
          content: this.content,
        },
        transaction: {
          destination_id: this.administrativeUnitId,
          to_user_id : this.employeeId,
        },
      };
      FolderService.transactFolder(this.folder.id, body)
        .then(() => {
          this.dialogSuccessTransaction = true;
        })
        .catch((err) => {
          this.onRequestError(err.response.data);
        })
        .finally(() => {
          this.loadingTransaction = false;
          this.sendingTransaction = false;
        });
    },
    requestPasswordOnCancelCallback() {
      return '';
    },
    selectDispatch() {
      if (this.dispatchId == null)
        return;
      const selectedDispatch = find(this.dispatches, ['id', this.dispatchId]);
      const { text } = selectedDispatch;
      this.content = text;
    },
    cancelTransaction() {
      this.content = '';
      this.$refs.form.reset();
      this.dialog = false;
    },
    transactionValidator(){
      return this.content !== '' && this.valid;
    },
    onRequestError(err) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: err.message || err || err[0],
        button: { show: true, text: 'Fechar', message: '' },
        timeout: 6000,
        messageIcon: 'mdi-alert-outline',
      });
    },
    close() {
      window.close();
    },
    toggle () {
      this.$nextTick(() => {
        if (this.allFolder) {
          this.selectedFolders = [];
        } else {
          this.selectedFolders = this.attachedFolders;
        }
      })
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    user() {
      return this.$store.getters.user;
    },
    attachedFolders() {
      return this.folder.attached_folders.folders;
    },
    allFolder () {
      return this.selectedFolders.length === this.attachedFolders.length;
    },
    someFolder () {
      return this.selectedFolders.length > 0 && !this.allFolder;
    },
    selectionIcon () {
      if (this.allFolder) {
        this.transactAll = true;
        return 'mdi-close-box';
      }

      this.transactAll = false;
      if (this.someFolder) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
};
</script>

<style scoped>
  .folder-container {
    border: 1px solid;
    border-radius: 3px;
    position: relative;
  }
  .folder-type-border {
    position: absolute;
    height: 100%;
    left: -1px;
    top: 0px;
    border-radius: 3px 0 0 3px;
    border-left: 5px solid;
    transition: ease-in-out .15s;
  }

  .v-tooltip{
    max-width: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/TransactFolder.vue